import { render, staticRenderFns } from "./zhucezh.vue?vue&type=template&id=1d603476&scoped=true"
import script from "./zhucezh.vue?vue&type=script&lang=js"
export * from "./zhucezh.vue?vue&type=script&lang=js"
import style0 from "./zhucezh.vue?vue&type=style&index=0&id=1d603476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d603476",
  null
  
)

export default component.exports